import { connect } from 'react-redux'
import { doSearchProducts } from 'ducks/integrations/shopify'
import { debounce } from 'util/functions'
import ProductsSearch from './view'

const perform = () => {
  return dispatch => ({
    searchProducts: debounce((integration, productTitle) => {
      dispatch(doSearchProducts(integration.id, productTitle))
    }, 300),
  })
}

export default connect(null, perform)(ProductsSearch)
